import PromptModalDefault from './PromptModal';

export default PromptModalDefault;



// WEBPACK FOOTER //
// ./src/client/Components/PromptModal/index.js